"use client"
import { useUpdate } from '@/core/hooks/use-update.hook';
import AuthRepo from '@/core/repos/auth.repo';
import container from '@/lib/di/container';
import { Spin } from 'antd';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';

const authRepo = container.get(AuthRepo);

const AuthProvider: React.FC = ({}) => {
    const navigate = useNavigate();
    const authState = authRepo.useAuth();
    const {pathname} = useLocation();
    const [initializing, setInitializing] = useState(true);

    useEffect(() => {
        let active = true;
        (async () => {
            await authRepo.initializeSession();
            if (active) {
                setInitializing(false);
            }
        })();
        return () => {
            active = false;
        };
    }, []);

    useUpdate(() => {
        if (initializing) return;
        if (!authState) {
            if (pathname !== '/login') {
                navigate('/login', {replace: true});
            }
        } else if (pathname === '/login') {
            navigate('/', {replace: true});
        }
    }, [authState, initializing, pathname]);

    if (initializing && pathname !== '/login') {
        return (
            <div className="fixed inset-0 flex items-center justify-center bg-white/80 z-[9999]">
                <Spin size="large" />
            </div>
        );
    }

    return (<></>)
}

export default AuthProvider;
